import type { AdGroupId, CampaignGroupId, CreativeGroupId, TargetGroupId } from '@hprofits/shared';
import type { RouteLocationResolved } from 'vue-router';
import { useRouter } from 'vue-router';

import { campaignRoutes } from './constants';

export const useRouteResolverCampaigns = () => {
  const router = useRouter();

  const noParamsRouteBuilder = (name: string) => (): RouteLocationResolved => router.resolve({ name });

  const campaignRouteBuilder =
    (name: string) =>
    (campaignGroupId: CampaignGroupId): RouteLocationResolved =>
      router.resolve({
        name,
        params: { id: campaignGroupId },
      });

  // TODO: Make better builder that calculates it's input type depending on param names collection & generics
  const campaignRouteBuilderWithId =
    <T extends number>(name: string, paramName: string) =>
    (campaignGroupId: CampaignGroupId, id: T): RouteLocationResolved =>
      router.resolve({
        name,
        params: { id: campaignGroupId, [paramName]: String(id) },
      });

  const list = noParamsRouteBuilder(campaignRoutes.list);
  const index: RouteLocationResolved = router.resolve({ name: campaignRoutes.index });
  const summary = campaignRouteBuilder(campaignRoutes.summary);
  const targetGroup = campaignRouteBuilderWithId<TargetGroupId>(campaignRoutes.targetGroup, 'targetId');
  const creativeGroup = campaignRouteBuilderWithId<CreativeGroupId>(campaignRoutes.creativeGroup, 'creativeId');
  const adGroup = campaignRouteBuilderWithId<AdGroupId>(campaignRoutes.adGroup, 'adId');

  return {
    list,
    index,
    summary,
    targetGroup,
    creativeGroup,
    adGroup,
  } satisfies Record<keyof typeof campaignRoutes, unknown>;
};
